import Plausible from 'plausible-tracker';

const { trackPageview, trackEvent } = Plausible({
  domain: import.meta.env.PLAUSIBLE_DOMAIN || 'werk42.eu',
  apiHost: import.meta.env.PLAUSIBLE_URL || 'https://plausible.codewerk.eu',
});

export { trackPageview, trackEvent };
